
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface TimeRangeSelectorProps {
  timeRange: "7days" | "30days" | "90days";
  setTimeRange: (value: "7days" | "30days" | "90days") => void;
}

const TimeRangeSelector = ({ timeRange, setTimeRange }: TimeRangeSelectorProps) => {
  return (
    <Tabs 
      value={timeRange} 
      onValueChange={(value: "7days" | "30days" | "90days") => setTimeRange(value)}
      className="w-full sm:w-[300px]"
    >
      <TabsList className="grid w-full grid-cols-3">
        <TabsTrigger value="7days">7 Days</TabsTrigger>
        <TabsTrigger value="30days">30 Days</TabsTrigger>
        <TabsTrigger value="90days">90 Days</TabsTrigger>
      </TabsList>
    </Tabs>
  );
};

export default TimeRangeSelector;
